<header class="page-header">
  <h1>Cadara Settings</h1>
  <p class="subtitle">
    Settings for the Cadara (NCS) billing integration. The Triple Check Report's "Compare with Cadara" mode
    reads the facility mapping below.
  </p>
</header>

<div *ngIf="loading" class="loading-banner">Loading…</div>
<div *ngIf="error" class="error-banner">{{ error }}</div>
<div *ngIf="facilityPage?.cadaraError" class="error-banner">{{ facilityPage?.cadaraError }}</div>

<section class="card" *ngIf="facilityPage">
  <div class="card__head">
    <h3 class="card__title">Facility mapping</h3>
    <button
      type="button"
      class="btn btn-ghost"
      [disabled]="checkingAll || !facilityPage.companies.length"
      (click)="checkAll()"
    >{{ checkingAll ? 'Checking…' : 'Check all' }}</button>
  </div>
  <p class="card__hint">
    Each facility is matched to the Cadara company with the same name. Change it here when the match is wrong.
    Check counts how many of the company's Cadara residents carry a PCC id from this facility.
  </p>
  <table class="map-table">
    <thead>
      <tr>
        <th>Facility</th>
        <th>Cadara company</th>
        <th>Check</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let facility of facilityPage.facilities; trackBy: trackByFacility">
        <td class="name-col">
          {{ facility.facilityName }}
          <div class="pcc-name" *ngIf="facility.pccName && facility.pccName !== facility.facilityName">{{ facility.pccName }}</div>
        </td>
        <td>
          <div class="company-line">
            <select
              [ngModel]="facility.companyId"
              (ngModelChange)="setCompany(facility, $event)"
              [disabled]="!facilityPage.companies.length"
              [attr.aria-label]="'Cadara company for ' + facility.facilityName"
            >
              <option *ngIf="facility.source === 'admin'" [ngValue]="'auto'">Match by name</option>
              <option [ngValue]="null">Not mapped</option>
              <option *ngFor="let c of facilityPage.companies" [ngValue]="c.companyId">{{ c.name }} ({{ c.companyId }})</option>
            </select>
          </div>
        </td>
        <td class="check-col">
          <div class="check-line">
            <button
              type="button"
              class="btn btn-ghost"
              *ngIf="facility.companyId !== null"
              [disabled]="checkingAll"
              (click)="checkMatch(facility, facility.companyId!)"
            >Check</button>
            <span class="match-text">{{ matchText(facility) }}</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</section>
